import React from 'react'
import { GlobalTypes, useGlobalState } from '../../contexts/global'
import Button from '../AppButton/Button'

const ModalConfirmOnlineMockExamSubmit = () => {
  const { state, dispatch } = useGlobalState()
  const onConfirm = state.modalProps.onConfirm as (() => void) | undefined

  const closeModal = () => {
    dispatch({ type: GlobalTypes.ToggleModal, modal: '' })
  }

  const handleConfirm = () => {
    closeModal()
    onConfirm?.()
  }

  return (
    <div className="modal-content h-text-center h-py-4">
      <p className="h-mb-2">
        Nahráli jste opravdu všechny soubory? Tuto akci po odevzdání nelze opakovat.
      </p>
      <Button color="primary" onClick={handleConfirm} className="h-mr-05">
        Odevzdat
      </Button>
      <Button color="outline" onClick={closeModal}>
        Zpět
      </Button>
    </div>
  )
}

export default ModalConfirmOnlineMockExamSubmit
